<template>
  <div class="w-full md:min-h-screen bg-blue-400 pt-10 pb-12 px-4">
    <div class="mx-auto max-w-screen-3xl">
      <video autoplay loop muted class="w-full min-h-[265px] object-cover">
        <source src="@/assets/images/dween-hero.webm" type="video/webm" />
      </video>

      <h1 class="mt-6 font-display font-semibold text-black text-4xl md:text-5xl xl:text-display-l">
        {{ $t('hero.heading') }}
      </h1>

      <div class="mt-10 flex space-x-5">
        <a :href="$bookDemoUrl()"
           target="_blank"
           class="rounded-[5px] bg-black text-white flex items-center font-regular font-text text-body-m px-4 py-2 transition-all hover:bg-blue-500"
        >
          {{ $t('requestAProposal') }}
        </a>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
</script>
